import React from 'react'
import { Suspense, lazy, useEffect, useState } from 'react'
import Logo from '../../../assets/glemo-logo.webp'
import UserLoginIcon from '../../../assets/icons/blue-user.svg'

import { formatMoneyReal, isMobile } from '../../../common_functions'
import { Button, TextInput } from '../../../components/common'
import { EnterpriseData } from '../../../interfaces/enterprise/enterpriseData'
import BaseInfos from '../BaseInfos'
import { SelectLocal } from '../../SelectLocal'
import CarouselEnterpriseModalMobileInitTest from '../CarouselEnterpriseModalMobileTest/indexInit'

const Header = lazy(() => import('../../../components/InternEnterprise/Header'))
const CardEnterpriseInternInfosPrice = lazy(
  () => import('../../../components/Cards/CardEnterpriseInternInfosPrice')
)
const SkeletonLoading = lazy(() => import('../../../components/common/SkeletonLoading'))

interface Props {
  dataEnterprise: EnterpriseData | undefined
  isLoadingEnterpriseData: boolean
  isSuccessEnterpriseData: boolean
}
export function InternEnterpriseInit({
  dataEnterprise,
  isLoadingEnterpriseData,
  isSuccessEnterpriseData
}: Props) {

  useEffect(() => {
    if(dataEnterprise?.Banner){
      const preload = document.createElement('link')
      preload.rel = 'preload'
      preload.as = 'image'
      preload.href = dataEnterprise.Banner
      document.head.appendChild(preload)
    }
  }, [dataEnterprise])
  return (
    <>
      <header className="header-mobile px-4 -mt-[150px] bg-white top-0 pt-5 pb-2 relative z-[99] lg:hidden w-[100vw]">
        <div id="mobileContainerSearch">
          <div className="grid grid-cols-3">
            <div className="m-auto ml-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                fill="currentColor"
                className="text-glemo-blue"
                viewBox="0 0 256 256"
              >
                <path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"></path>
              </svg>
            </div>
            <div className="m-auto">
              <a href={'/'}>
                <Suspense fallback={<SkeletonLoading />}>
                  <img alt="Glemo Logo" src={Logo} className="w-full aspect-[191/69]" />
                </Suspense>
              </a>
            </div>
          </div>
        </div>
      </header>
      <div className="hidden lg:block bg-white text-center py-3">
        {/* <a href={'/'} className="w-fit">
          <img alt="Glemo Logo" src={Logo} className="w-[100px] m-auto" />
        </a> */}
        <header
          className={
            'desktop-header -mt-[150px] header w-full pt-2 top-0 pb-5 bg-off-white border-b border-gray-300 items-center justify-center z-[99] hidden md:block'
          }
        >
          <div className="h-full w-full text-2xl flex flex-col justify-between m-auto">
            <div className="w-full flex items-center gap-4 px-5 lg:px-10">
              <span className="min-w-[129px] min-h-[78px] flex place-items-center">
                <Suspense fallback={<SkeletonLoading />}>
                  <img
                    alt="Glemo Logo"
                    className="m-auto w-[129px] h-[47px]"
                    src={Logo}
                    width={129}
                    height={47}
                  />
                </Suspense>
              </span>

              <div className="flex items-center gap-3 py-4 px-3 h-12 rounded border-1 border-gray-200 w-full focus-within:border-2 focus-within:border-blue-700 bg-gray-100">
                <span className="w-6 h-6 text-blue-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    width="28"
                    height="28"
                    className="-mt-[4px] justify-self-center"
                    viewBox="0 0 256 256"
                  >
                    <path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path>
                  </svg>
                </span>
                <input
                  id="enderecoBuscaEmpreendimento"
                  placeholder="Busque seu imóvel aqui"
                  className="w-[inherit] bg-gray-100 flex-1 text-md outline-none placeholder:text-gray-600 max-w-100"
                  value=""
                />
                <span className="w-6 h-6 text-blue-700">
                  <img
                    src="/src/assets/icons/separator-microphone-gray.svg"
                    className="w-1 -mt-[5px]"
                  />
                </span>
                <span className="w-6 h-6 text-blue-700">
                  <img src="/src/assets/icons/microphone-blue.svg" className="cursor-pointer" />
                </span>
              </div>
              <Button
                variant="secondary"
                aria-label="Filtrar"
                id="openSectionFilter"
                value="Filtrar"
              >
                <svg
                  width="19"
                  height="18"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.78573 9.02344H0.928589M18.0714 14.7377L15.2143 14.7377M18.0714 3.30915L10.6429 3.30916M8.35716 3.30915L0.92859 3.30915M6.07145 9.02344L18.0714 9.02344M12.9286 14.7377H0.92859M12.9286 12.452V17.0234L15.2143 17.0234V12.452L12.9286 12.452ZM3.78573 6.73772V11.3092H6.07145V6.73772H3.78573ZM8.35716 1.02344V5.59487H10.6429V1.02344L8.35716 1.02344Z"
                    stroke="#0059FF"
                  />
                </svg>
              </Button>
              <Button variant="primary" id="filterBtnNavDesktop" aria-label="Buscar" value="Buscar">
                <>BUSCAR </>
              </Button>
              <Button variant="transparent" id="headerNavVisualizados">
                <div className="text-gray-700 px-0 py-0 hover:bg-gray-100 flex justify-center items-center gap-2.5 rounded transition-colors ease-in-out duration-250">
                  <span className="bg-gray-100 text-blue-700 rounded px-4 py-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      width="20"
                      viewBox="0 0 256 256"
                    >
                      <path d="M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm-8-48A95.44,95.44,0,0,0,60.08,60.15C52.81,67.51,46.35,74.59,40,82V64a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16H49c7.15-8.42,14.27-16.35,22.39-24.57a80,80,0,1,1,1.66,114.75,8,8,0,1,0-11,11.64A96,96,0,1,0,128,32Z"></path>
                    </svg>
                  </span>
                  <span className="font-semibold tracking-wider pr-4 md:hidden lg:inline-block">
                    Visualizados
                  </span>
                </div>
              </Button>

              <Button variant="transparent" id="headerNavFavoritos">
                <div className="text-gray-700 px-0 py-0 hover:bg-gray-100 flex justify-center items-center gap-2.5 rounded transition-colors ease-in-out duration-250">
                  <span className="bg-gray-100 text-blue-700 rounded px-4 py-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      fill="currentColor"
                      viewBox="0 0 256 256"
                    >
                      <path d="M178,32c-20.65,0-38.73,8.88-50,23.89C116.73,40.88,98.65,32,78,32A62.07,62.07,0,0,0,16,94c0,70,103.79,126.66,108.21,129a8,8,0,0,0,7.58,0C136.21,220.66,240,164,240,94A62.07,62.07,0,0,0,178,32ZM128,206.8C109.74,196.16,32,147.69,32,94A46.06,46.06,0,0,1,78,48c19.45,0,35.78,10.36,42.6,27a8,8,0,0,0,14.8,0c6.82-16.67,23.15-27,42.6-27a46.06,46.06,0,0,1,46,46C224,147.61,146.24,196.15,128,206.8Z"></path>
                    </svg>
                  </span>
                  <span className="font-semibold tracking-wider pr-4 md:hidden lg:inline-block">
                    Favoritos
                  </span>
                </div>
              </Button>

              <span className="text-blue-700 flex text-lg font-semibold tracking-wider">
                <span className="me-2 inline-block">Entrar</span>
                <img
                  src={UserLoginIcon}
                  width={20}
                  alt="User Icon"
                  className="m-auto inline-block"
                />
              </span>
            </div>
            <hr className="my-4 opacity-[0.2]" />
            <div className="dropdowns-menu w-full text-xl text-black-60 flex items-center justify-center gap-16">
              <SelectLocal />
              <button className="flex items-center gap-1 font-semibold cursor-pointer">
                Para Empresas
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  viewBox="0 0 256 256"
                >
                  <rect width="256" height="256" fill="none"></rect>
                  <polyline
                    points="208 96 128 176 48 96"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="24"
                  ></polyline>
                </svg>
              </button>
              <button className="flex items-center gap-1 font-semibold cursor-pointer">
                Para você
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  viewBox="0 0 256 256"
                >
                  <rect width="256" height="256" fill="none"></rect>
                  <polyline
                    points="208 96 128 176 48 96"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="24"
                  ></polyline>
                </svg>
              </button>
              <button className="flex items-center gap-1 font-semibold cursor-pointer">
                Sobre o glemO
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  viewBox="0 0 256 256"
                >
                  <rect width="256" height="256" fill="none"></rect>
                  <polyline
                    points="208 96 128 176 48 96"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="24"
                  ></polyline>
                </svg>
              </button>
            </div>
          </div>
        </header>
      </div>
      <div className="lg:pt-5 lg:-mt-[150px] -mt-[47px]">
        {isLoadingEnterpriseData && (
          <>
            <SkeletonLoading height={400} />
          </>
        )}
        {isSuccessEnterpriseData && dataEnterprise && (
          <>
            <Suspense fallback={<SkeletonLoading />}>
              <div className="carousel w-full px-5 lg:mt-[92px]">
                <>
                  <div className="w-full relative">
                    {dataEnterprise.Banner ? (<img
                      src={dataEnterprise?.Banner} alt="Banner Principal"
                      // @ts-ignore
                      fetchpriority="high"
                      className="w-full aspect-[360/290] relative rounded mt-10"
                    />) : (<SkeletonLoading height={300}></SkeletonLoading>)}
                    <div className="w-full aspect-[360/290] top-0 absolute rounded bg-no-repeat bg-cover bg-center">
                      <div className="h-full">
                        {/* left button caroussel */}
                        <button className="inline-block h-full disabled:opacity-75">
                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                            className="inline-block h-full"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="36"
                              y="36"
                              width="36"
                              height="36"
                              transform="rotate(-180 36 36)"
                              fill="#0A0A0A"
                              fill-opacity="0.8"
                            />
                            <path
                              d="M23.8848 9.77L22.1148 8L12.1148 18L22.1148 28L23.8848 26.23L15.6548 18L23.8848 9.77Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                        {/* right arrow carousel */}
                        <button className="inline-block h-full float-right disabled:opacity-75">
                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 36 36"
                            fill="none"
                            className=""
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect width="36" height="36" fill="#0A0A0A" fill-opacity="0.8" />
                            <path
                              d="M12.1152 26.23L13.8852 28L23.8852 18L13.8852 8L12.1152 9.77L20.3452 18L12.1152 26.23Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </div>
                      <div className="absolute bottom-0 mb-3 ps-3">
                        <button
                          type="button"
                          className="bg-[#0A0A0ACC] text-white px-1 text-center align-middle rounded-sm"
                        >
                          <div className="-mt-1">
                            <span className="m-auto inline-block">
                              <svg
                                width="19"
                                height="19"
                                viewBox="0 0 19 19"
                                fill="none"
                                className="inline-block -mt-2"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.5 12.6667C10.8117 12.6667 11.875 11.6035 11.875 10.2917C11.875 8.98004 10.8117 7.91675 9.5 7.91675C8.18829 7.91675 7.125 8.98004 7.125 10.2917C7.125 11.6035 8.18829 12.6667 9.5 12.6667Z"
                                  stroke="white"
                                  strokeWidth="1.58333"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M2.375 13.3001V7.28341C2.375 6.39667 2.375 5.95329 2.54758 5.6146C2.69937 5.31667 2.94159 5.07445 3.23952 4.92266C3.57821 4.75008 4.02159 4.75008 4.90833 4.75008H5.74326C5.84058 4.75008 5.88925 4.75008 5.93414 4.74494C6.1684 4.71811 6.3785 4.58826 6.50725 4.39074C6.53193 4.35288 6.5537 4.30934 6.59722 4.2223C6.68427 4.04821 6.7278 3.96115 6.77716 3.88544C7.03467 3.4904 7.45487 3.2307 7.9234 3.17703C8.01317 3.16675 8.11047 3.16675 8.30514 3.16675H10.6949C10.8895 3.16675 10.9868 3.16675 11.0766 3.17703C11.5451 3.2307 11.9653 3.4904 12.2229 3.88544C12.2722 3.96115 12.3157 4.04823 12.4028 4.2223C12.4463 4.30935 12.468 4.35288 12.4927 4.39074C12.6215 4.58826 12.8316 4.71811 13.0658 4.74494C13.1108 4.75008 13.1594 4.75008 13.2568 4.75008H14.0917C14.9784 4.75008 15.4218 4.75008 15.7605 4.92266C16.0584 5.07445 16.3007 5.31667 16.4524 5.6146C16.625 5.95329 16.625 6.39667 16.625 7.28341V13.3001C16.625 14.1868 16.625 14.6302 16.4524 14.9689C16.3007 15.2668 16.0584 15.5091 15.7605 15.6608C15.4218 15.8334 14.9784 15.8334 14.0917 15.8334H4.90833C4.02159 15.8334 3.57821 15.8334 3.23952 15.6608C2.94159 15.5091 2.69937 15.2668 2.54758 14.9689C2.375 14.6302 2.375 14.1868 2.375 13.3001Z"
                                  stroke="white"
                                  strokeWidth="1.58333"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <span className="ps-2 text-2xl">-</span>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </Suspense>
          </>
        )}
        <>
          <div className="flex m-auto w-fit gap-3">
            <div className="group-actions gap-2 w-[50px] m-auto lg:mr-0">
              <div className="">
                <a href="#">
                  <div className="border border-gray-200 content-center rounded-full w-[48px] h-[48px] text-center cursor-pointer">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        className="inline-block"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.9966 16.1582C16.4425 16.1582 15.9311 16.3495 15.5305 16.669L11.5016 13.801C11.5691 13.4367 11.5691 13.0633 11.5016 12.699L15.5305 9.83099C15.9311 10.1505 16.4425 10.3418 16.9966 10.3418C18.2838 10.3418 19.33 9.3125 19.33 8.04592C19.33 6.77934 18.2838 5.75 16.9966 5.75C15.7094 5.75 14.6633 6.77934 14.6633 8.04592C14.6633 8.26786 14.6944 8.48023 14.7547 8.68304L10.928 11.4094C10.3602 10.669 9.45801 10.1888 8.44107 10.1888C6.72218 10.1888 5.32996 11.5587 5.32996 13.25C5.32996 14.9413 6.72218 16.3112 8.44107 16.3112C9.45801 16.3112 10.3602 15.831 10.928 15.0906L14.7547 17.817C14.6944 18.0198 14.6633 18.2341 14.6633 18.4541C14.6633 19.7207 15.7094 20.75 16.9966 20.75C18.2838 20.75 19.33 19.7207 19.33 18.4541C19.33 17.1875 18.2838 16.1582 16.9966 16.1582ZM16.9966 7.05102C17.5547 7.05102 18.0077 7.49681 18.0077 8.04592C18.0077 8.59503 17.5547 9.04082 16.9966 9.04082C16.4386 9.04082 15.9855 8.59503 15.9855 8.04592C15.9855 7.49681 16.4386 7.05102 16.9966 7.05102ZM8.44107 14.9337C7.49801 14.9337 6.72996 14.1779 6.72996 13.25C6.72996 12.3221 7.49801 11.5663 8.44107 11.5663C9.38412 11.5663 10.1522 12.3221 10.1522 13.25C10.1522 14.1779 9.38412 14.9337 8.44107 14.9337ZM16.9966 19.449C16.4386 19.449 15.9855 19.0032 15.9855 18.4541C15.9855 17.905 16.4386 17.4592 16.9966 17.4592C17.5547 17.4592 18.0077 17.905 18.0077 18.4541C18.0077 19.0032 17.5547 19.449 16.9966 19.449Z"
                          fill="#0059FF"
                        />
                      </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="w-fit max-w-full">
              <div className="min-w-[50px] m-auto float-right">
                <button className="h-full w-full" aria-label='Favoritar Empreendimento'>
                  <div className="border border-gray-200 content-center rounded-full w-[48px] h-[48px] text-center cursor-pointer">
                      <>
                        <svg
                          width="21"
                          height="19"
                          viewBox="0 0 21 19"
                          fill="none"
                          className="inline-block"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.64799 3.21135C2.23013 3.62921 1.89865 4.12529 1.6725 4.67126C1.44635 5.21723 1.32996 5.8024 1.32996 6.39335C1.32996 6.9843 1.44635 7.56947 1.6725 8.11544C1.89865 8.66141 2.23013 9.15749 2.64799 9.57535L10.33 17.2573L18.012 9.57535C18.8559 8.73143 19.33 7.58683 19.33 6.39335C19.33 5.19987 18.8559 4.05527 18.012 3.21135C17.1681 2.36743 16.0235 1.89332 14.83 1.89332C13.6365 1.89332 12.4919 2.36743 11.648 3.21135L10.33 4.52935L9.012 3.21135C8.59413 2.79348 8.09805 2.46201 7.55208 2.23586C7.00611 2.00971 6.42095 1.89331 5.83 1.89331C5.23904 1.89331 4.65388 2.00971 4.10791 2.23586C3.56194 2.46201 3.06586 2.79348 2.64799 3.21135V3.21135Z"
                            stroke="#F15C00"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <section className="container-responsive-view gap-4 lg:mt-10">
            <div className="lg:grid lg:grid-cols-3">
              <div className="lg:col-span-3">
                <div className="lg:grid lg:grid-cols-3">
                  {/* INFORMACOES  */}
                  <div className="lg:pl-10 order-2">
                    <div className="card-enterprise-intern-infos-prices lg:hidden fixed bottom-0 shadow-lg w-full left-0 z-[10]">
                      <div
                        className="grid grid-cols-2 mx-5 shadow-lg py-5 px-3 bg-white m-auto"
                        style={{ boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.2)' }}
                      >
                        {/* {isPromotion && <img src={TagPromotion} width={40} className='absolute right-10 top-0 -mt-[3px]'/>} */}
                        <div className="m-auto ms-0">
                          <h6 className="text-base font-semibold text-[#333]">
                            Valor
                          </h6>
                          <h6 className="text-[#4D4D4D] text-lg font-semibold">
                            Sob Consulta
                          </h6>
                        </div>
                        <div className="m-auto me-0">
                          <Button
                            variant="primary-gradient"
                            className="font-bold w-full text-white btn-submit-modal-form-contact"
                            paddingXClass="px-2"
                          >
                            <small>TENHO INTERESSE</small>
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {isSuccessEnterpriseData && dataEnterprise ? (
                    <>
                      <div
                        className="lg:col-span-2 lg:pr-10 mt-3 lg:mt-auto"
                        style={{ overflowWrap: 'break-word' }}
                      >
                        <div>
                          <h1 className="text-3xl lg:text-[50px] leading-[48px] font-bold mt-2 lg:mt-5">
                            {dataEnterprise?.Title ?? ''}
                          </h1>
                          <hr className="opacity-20 my-3" />
                          <p
                            className="text-lg lg:text-xl text-[#52525B] fw-normal -z-[1]"
                            style={{ position: 'relative' }}
                          >
                            <span className="">
                              {/* <MapPin weight="fill" className="inline-block" /> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                className="inline-block"
                              >
                                <path
                                  d="M9.99992 9.99935C9.08325 9.99935 8.33325 9.24935 8.33325 8.33268C8.33325 7.41602 9.08325 6.66602 9.99992 6.66602C10.9166 6.66602 11.6666 7.41602 11.6666 8.33268C11.6666 9.24935 10.9166 9.99935 9.99992 9.99935ZM14.9999 8.49935C14.9999 5.47435 12.7916 3.33268 9.99992 3.33268C7.20825 3.33268 4.99992 5.47435 4.99992 8.49935C4.99992 10.4493 6.62492 13.0327 9.99992 16.116C13.3749 13.0327 14.9999 10.4493 14.9999 8.49935ZM9.99992 1.66602C13.4999 1.66602 16.6666 4.34935 16.6666 8.49935C16.6666 11.266 14.4416 14.541 9.99992 18.3327C5.55825 14.541 3.33325 11.266 3.33325 8.49935C3.33325 4.34935 6.49992 1.66602 9.99992 1.66602Z"
                                  fill="black"
                                  fill-opacity="0.45"
                                />
                              </svg>
                            </span>{' '}
                            Localização privilegiada em
                            <h2 className="fw-bold opacity-90 mt-2 text-[#1F1E1E]">
                              {dataEnterprise?.Location}
                            </h2>
                          </p>
                          <hr className="opacity-20 my-3" />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* <div id="loadingBox"></div> */}
                    </>
                  )}
                  {/* <div>
                    <div className="flex border-b-1 border-gray-100">
                      <button
                        className={
                          'text-caption mt-2 lg:mt-auto lg:text-2xl font-bold pb-2 w-[150px] max-w-full text-[#F15C00] border-b-2'
                        }
                      >
                        Detalhes
                      </button>
                      <button
                        className={
                          'text-caption mt-2 lg:mt-auto lg:text-2xl font-bold pb-2 w-[150px] max-w-full text-[#000000A6] '
                        }
                      >
                        Galeria
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </section>
          {/* {isSuccessEnterpriseData && dataEnterprise ? (
            <>
              <div className="mt-10 px-5">
                <BaseInfos
                  Id={dataEnterprise?.Id}
                  Description={dataEnterprise?.Description}
                  StatusId={dataEnterprise?.StatusId}
                  ConstructionCompanyId={dataEnterprise?.ConstructionCompanyId}
                />
              </div>
            </>
          ) : (
            <div className="px-5 mt-4">
              <SkeletonLoading height={50} />
            </div>
          )} */}
        </>
      </div>
    </>
  )
}
